import { SET_BROADCASTS, RESET, SAVE_BROADCAST, DELETE_BROADCAST } from './actionTypes'
import { hangup } from '../otuVision/actions'

export function reset() {
  return { 
    type : RESET
  }
}

export function getBroadcasts() {
  return (dispatch, getState) => {
    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=broadcast.getBroadcasts',{},{
      responseType : 'json',
        callback : function ( broadcasts ) {
          dispatch( {
            type : SET_BROADCASTS,
            broadcasts
          } )
        }
      } )
    }
}


export function showPlanBroadcast( options = {} ){

  return (dispatch, getState) => {
    const url="index.php?component=com_otu_op&task=broadcast.showPlanBroadcast" + ( options.broadcast ? '&broadcastId='+options.broadcast.id:'');
    otuApp.triggerAjaxGet(url,{"attr":{"data-hide-template-position":"columns-all"}});	    
  }

}

export function showJoinBroadcast( options = {} ){

  return (dispatch, getState) => {
    const url="index.php?component=com_otu_op&task=broadcast.showJoinBroadcast" + ( options.broadcast ? '&broadcastId='+options.broadcast.id:'');
    otuApp.triggerAjaxGet(url,{"attr":{"data-hide-template-position":"columns-all"}});	    
  }

}

export function saveBroadcast ( broadcast ) {

  return async ( dispatch, getState ) => {

    const data = {
      new : + broadcast.new,
      id : broadcast.id,
      name : broadcast.name,
      type : broadcast.type,
      classrooms: broadcast.classrooms,
      date : broadcast.date,
      sendInvite : broadcast.sendInvite ? 1 : 0
    }

    console.log ('Broadcast - Saving',data)

    return new Promise((resolve,reject) => {
      otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=broadcast.saveBroadcast',data,{
        responseType : 'json',
        callback : function ( broadcast ) {
          dispatch( {
            type : SAVE_BROADCAST,
            broadcast
          } )
          resolve(broadcast)        
        },
        errorCallback : function () {
          reject('Broadcast - Save Failed')
        }
        } )
    })

  }

}

export function startBroadcast ( broadcast ) {

  return async ( dispatch, getState ) => {

    const data = {
      id : broadcast.id,
    }

    console.log ('Broadcast - Starting Broadcast',data)

    return new Promise((resolve,reject) => {
      otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=broadcast.startBroadcast',data,{
        responseType : 'json',
        callback : function ( broadcast ) {
          /*
          dispatch( {
            type : SAVE_BROADCAST,
            broadcast
          } )
          */
          resolve()        
        },
        errorCallback : function () {
          reject('Broadcast - Start Failed')
        }
        } )
    })

  }

}

export function joinBroadcast ( broadcast ) {

  return async ( dispatch, getState ) => {

    const data = {
      id : broadcast.id,
    }

    console.log ('Broadcast - Joining Broadcast',data)

    return new Promise((resolve,reject) => {
      otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=broadcast.joinBroadcast',data,{
        responseType : 'json',
        callback : function ( broadcast ) {
          /*
          dispatch( {
            type : SAVE_BROADCAST,
            broadcast
          } )
          */
          resolve()        
        },
        errorCallback : function () {
          reject('Broadcast - Join Failed')
        }
        } )
    })

  }

}



export function deleteBroadcast ( broadcast ) {
  return ( dispatch, getState ) => {

    const data = {
      id: broadcast.id
    }

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=broadcast.deleteBroadcast',data,{
      responseType : 'json',
      callback : function ( broadcast ) {
        dispatch( {
          type : DELETE_BROADCAST,
          id : broadcast.id
        } ) 
      }
      } )

    }
}
